import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CloseModal, Modal } from '../../modal.models';

@Component({
	selector: 'cmv-confirm-dialog',
	templateUrl: './confirm-dialog.component.html',
	styleUrls: ['./confirm-dialog.component.scss'],
})
export class ConfirmDialogComponent implements Modal, CloseModal {
	@Input()
	isModalVisible: boolean;
	@Input() title: string;
	@Input() message: string;

	@Output() acceptEvent: EventEmitter<void> = new EventEmitter();
	constructor() {}
	onCloseModal(): void {
		this.acceptEvent.emit();
	}
}
